import React from 'react';
import { TableCell, TableSortLabel } from '@material-ui/core';

const SortableHeaderCell = ({ sortKey, sortInfo, createSortHandler, children, ...cellProps }) => {
    return (
        <TableCell {...cellProps}>
            <TableSortLabel
                active={sortInfo.sort === sortKey}
                direction={sortInfo.sort === sortKey ? sortInfo.sort_by : 'asc'}
                onClick={() => createSortHandler(sortKey)}
            >
                {children}
            </TableSortLabel>
        </TableCell>
    )
}
export default SortableHeaderCell;
